import React, { useTransition, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as SEARCH_ACTIOS } from "../redux/search";

import { getObjectStringValues, normalizeQuery } from "../utils";

const useSearch = () => {
  const dataArr = useRef(null);

  const dispatch = useDispatch();
  const [pending, setTransition] = useTransition();
  const { data, query } = useSelector((state) => state.search);

  const filterData = (query, data) => {
    const processedQuery = normalizeQuery(query);
    let preliminaryData = {};
    let response = [];

    for (let user of dataArr.current) {
      const [uid, values] = user;
      let ocurrences = query ? 0 : 1;

      for (let value of values) {
        for (let queryString of processedQuery) {
          if (value.includes(queryString)) {
            ocurrences += 1;
          }
        }

        if (value.includes(query)) {
          ocurrences += 1;
        }
      }

      if (ocurrences >= processedQuery.length) {
        preliminaryData[uid] = ocurrences;
      }
    }

    Object.entries(preliminaryData).forEach(([key, value]) => {
      response.push({ ocurrences: value, uid: key, ...data[key] });
    });

    return response;
  };

  const onQueryChangeHandler = (query, data) => {
    if (!data) return;
    if (!dataArr.current) dataArr.current = getObjectStringValues(data);

    setTransition(() => {
      dispatch(SEARCH_ACTIOS.setFilteredData(filterData(query, data)));
    });
  };

  useEffect(() => {
    onQueryChangeHandler(query, data);
  }, [query, data]);

  useEffect(() => {
    dispatch(SEARCH_ACTIOS.queryChanged(pending));
  }, [dispatch, pending]);
};

export default useSearch;
